/**
 * Horné filtre cust019/cust021 – parita zoznamu FP (bez závislosti na service/).
 */

/** Hodnoty selectu stavu – rovnaké ako Firemný portál. */
export const CRM_COMM_TICKETS_STATUS_VALUES = Object.freeze({
  OPEN: 'Otvorený',
  CLOSED: 'Uzavretý',
  REJECTED: 'Neschválený',
  CANCELLED: 'Stornovaný',
  ALL: 'Všetky',
});

export const CRM_COMM_TICKETS_SCOPE_VALUES = Object.freeze({
  ALL: 'Všetky',
  MINE: 'Mnou vytvorené',
  MENTIONED: 'Spomenutý',
  EXECUTOR: 'Vykonávateľ',
});

export const CRM_COMM_TICKETS_DEFAULT_STATUS = CRM_COMM_TICKETS_STATUS_VALUES.OPEN;

/**
 * @param {string} statusValue
 * @returns {string|undefined}
 */
export function mapCrmCommTicketsStatusToFilterStatus(statusValue) {
  const v = String(statusValue || '').trim();
  if (!v || v === CRM_COMM_TICKETS_STATUS_VALUES.ALL || v === 'Všetky') return undefined;
  if (v === CRM_COMM_TICKETS_STATUS_VALUES.OPEN || v === 'open') return CRM_COMM_TICKETS_STATUS_VALUES.OPEN;
  if (v === CRM_COMM_TICKETS_STATUS_VALUES.CLOSED || v === 'closed') return CRM_COMM_TICKETS_STATUS_VALUES.CLOSED;
  if (v === CRM_COMM_TICKETS_STATUS_VALUES.REJECTED || v === 'closed_rejected') return CRM_COMM_TICKETS_STATUS_VALUES.REJECTED;
  if (v === CRM_COMM_TICKETS_STATUS_VALUES.CANCELLED || v === '__cancelled__') return CRM_COMM_TICKETS_STATUS_VALUES.CANCELLED;
  return v;
}

/**
 * @deprecated Použiť mapCrmCommTicketsStatusToFilterStatus (crm_tickets layout).
 */
export function mapCrmCommTicketsStatusToApi(statusValue) {
  const fp = mapCrmCommTicketsStatusToFilterStatus(statusValue);
  if (!fp) return undefined;
  if (fp === CRM_COMM_TICKETS_STATUS_VALUES.OPEN) return 'open';
  if (fp === CRM_COMM_TICKETS_STATUS_VALUES.CLOSED) return 'closed';
  if (fp === CRM_COMM_TICKETS_STATUS_VALUES.REJECTED) return 'closed_rejected';
  if (fp === CRM_COMM_TICKETS_STATUS_VALUES.CANCELLED) return '__cancelled__';
  return fp;
}

/** @param {string} raw */
export function normalizeCrmCommTicketsStatusFromMask(raw) {
  const v = String(raw || '').trim();
  if (v === 'open') return CRM_COMM_TICKETS_STATUS_VALUES.OPEN;
  if (v === 'closed') return CRM_COMM_TICKETS_STATUS_VALUES.CLOSED;
  if (v === 'Všetky') return CRM_COMM_TICKETS_STATUS_VALUES.ALL;
  return v || CRM_COMM_TICKETS_DEFAULT_STATUS;
}

/** @param {string} raw */
export function normalizeCrmCommTicketsScopeFromMask(raw) {
  const v = String(raw || '').trim();
  if (v === 'Mnou otvorené tikety') return CRM_COMM_TICKETS_SCOPE_VALUES.MINE;
  return v || CRM_COMM_TICKETS_SCOPE_VALUES.ALL;
}

/**
 * @param {Record<string, unknown>} extra
 * @param {string} scopeValue
 * @param {{ lockMineOnly?: boolean }} opts
 */
export function applyCrmCommTicketsScopeToRequestExtra(extra, scopeValue, { lockMineOnly = false } = {}) {
  if (lockMineOnly) {
    extra.mine_only = 1;
    extra.filter_contractorValue = CRM_COMM_TICKETS_SCOPE_VALUES.MINE;
    return;
  }
  const v = String(scopeValue || '').trim();
  if (v === CRM_COMM_TICKETS_SCOPE_VALUES.MINE) {
    extra.mine_only = 1;
    extra.filter_contractorValue = CRM_COMM_TICKETS_SCOPE_VALUES.MINE;
  } else if (v === CRM_COMM_TICKETS_SCOPE_VALUES.MENTIONED) {
    extra.mine_only = 0;
    extra.filter_contractorValue = CRM_COMM_TICKETS_SCOPE_VALUES.MENTIONED;
  } else if (v === CRM_COMM_TICKETS_SCOPE_VALUES.EXECUTOR) {
    extra.mine_only = 0;
    extra.filter_contractorValue = CRM_COMM_TICKETS_SCOPE_VALUES.EXECUTOR;
  } else {
    extra.mine_only = 0;
    delete extra.filter_contractorValue;
  }
}
